import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { IDefaultPaymentMethod } from '@mopla/data-models';

interface IPaymentMethodStore {
	/** State */
	paymentMethod: IDefaultPaymentMethod | null;
	isLoading: boolean;
	isSaving: boolean;

	/** Actions */
	setPaymentMethod: (method: IDefaultPaymentMethod | null) => void;
	setIsLoading: (loading: boolean) => void;
	setIsSaving: (saving: boolean) => void;
	reset: () => void;
}

const initialState: Pick<
	IPaymentMethodStore,
	'paymentMethod' | 'isLoading' | 'isSaving'
> = {
	paymentMethod: null,
	isLoading: false,
	isSaving: false,
};

export const usePaymentMethodStore = create<IPaymentMethodStore>()(
	devtools(
		(set) => ({
			...initialState,

			setPaymentMethod: (paymentMethod) => set({ paymentMethod }),
			setIsLoading: (isLoading) => set({ isLoading }),
			setIsSaving: (isSaving) => set({ isSaving }),

			reset: () => set(initialState),
		}),
		{ name: 'PaymentMethodStore' }
	)
);
